import axios from "axios";
import { getIdToken, getImpersonatedUser } from "./session";

export const axiosPost = async (url, payload) => {
  const { idToken } = await getIdToken();
  return  axios
    .post(
      url,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`
        }
      }
    );
};

export const axiosPut = async (url, payload) => {
  const { idToken } = await getIdToken();
  return  axios
    .put(
      url,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`
        }
      }
    );
};

export const axiosPostMultipart = (url, formData) => {
  const { idToken } = getIdToken();
  return  axios
    .post(
      url,
      formData,
      {
        headers: {
          Authorization: `Bearer ${idToken}`
        }
      }
    );
};
export const axiosGet = (url) => {
  const { idToken } = getIdToken();
  return  axios
    .get(
      url,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`
        },
      }
    );
};
